import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.NX_FIREBASE_API_KEY,
  appId: process.env.NX_FIREBASE_APP_ID,
  authDomain: process.env.NX_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.NX_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.NX_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NX_FIREBASE_STORAGE_BUCKET,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
